class PostLoaderCollection {

	/**
	 *
	 * @param {PostLoader[]} loaders
	 */
	constructor(loaders= []) {
		/**
		 * @type {PostLoader[]}
		 */
		this.loaders = loaders;
	}

	/**
	 * @param {PostLoader} loader
	 */
	add(loader) {
		this.loaders.push(loader);
	}

	/**
	 * @param {string} id
	 * @return {PostLoader|null}
	 */
	getByContainerId(id) {
		let out;

		this.loaders.forEach(item => {
			if (item.id === id) {
				out = item;
				return;
			}
		});

		return out;
	}

	/**
	 *
	 * @param {string} postType
	 * @return {PostLoader|null}
	 */
	getByContainerPostType(postType) {
		let out;

		this.loaders.forEach(item => {
			if (item.postType === postType) {
				out = item;
				return;
			}
		});

		return out;
	}
}

export default PostLoaderCollection;
